import { render, staticRenderFns } from "./LargeFeed.vue?vue&type=template&id=ba62b78e&"
import script from "./LargeFeed.vue?vue&type=script&lang=js&"
export * from "./LargeFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports